import { forwardRef } from 'react';
import MuiTextField, { type TextFieldProps as MuiTextFieldProps } from '@mui/material/TextField';

export type TextFieldProps = MuiTextFieldProps;

export const TextField = forwardRef<HTMLDivElement, TextFieldProps>(
  ({ variant = 'outlined', margin = 'normal', fullWidth = true, ...rest }, ref) => (
    <MuiTextField ref={ref} variant={variant} margin={margin} fullWidth={fullWidth} {...rest} />
  )
);

TextField.displayName = 'TextField';
